import { Extension } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';
import { PluginKey } from 'prosemirror-state';
import MentionSuggestionCommands from '../MentionSuggestionCommands';

export const MentionSuggestionPluginKey = new PluginKey('mentionSuggestion');

export const MentionSuggestionExtension = Extension.create({
  name: 'mentionSuggestion',

  addProseMirrorPlugins() {
    return [
      Suggestion({
        pluginKey: MentionSuggestionPluginKey,
        editor: this.editor,
        char: '@',
        command: ({ editor, range, props }) => {
          // command is called when a suggestion item is selected
          editor.chain().focus().deleteRange(range).setMention(props.id, props.displayName).run();
        },
        items: MentionSuggestionCommands.items,
        render: MentionSuggestionCommands.render,
      }),
    ];
  },
});
